// extracted by mini-css-extract-plugin
export default {"main-header":"Header_main-header__P4d3m","theme-switcher-wrapper":"Header_theme-switcher-wrapper__s1AnT","switch-theme-icon":"Header_switch-theme-icon__0wxMs"};